import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

import * as SecurityHelper from '../../../helpers/securityHelper';
import { IconAccountCircle } from '../../sharedComponents/icons/Icons';

export default function useProfilePicture() {
    // Redux state
    const photoId = useSelector(
        (state) => state.auth.account?.account?.profile_picture_id
    );

    // Local state
    const [photoUrl, setPhotoUrl] = useState('');

    // On mount/when photoId changes, get the photoUrl
    useEffect(() => {
        let isMounted = true;

        async function getProfilePicture() {
            if (!photoId) {
                return;
            }

            try {
                const url = `${process.env.API}/media/external/${photoId}`;
                const options = {
                    headers: { Authorization: SecurityHelper.getAuthHeader() },
                };
                const response = await axios.get(url, options);

                if (isMounted) {
                    setPhotoUrl(response.data.url);
                }
            } catch {
                if (isMounted) {
                    setPhotoUrl('');
                }
            }
        }

        getProfilePicture();

        return () => {
            isMounted = false;
        };
    }, [photoId]);

    // If we have a URL, return the user's image
    if (photoUrl) {
        return <img src={photoUrl} alt="Profile avatar" />;
    }

    // Otherwise we use the icon
    return (
        <div className="nav-mobile-user-icon">
            <IconAccountCircle />
        </div>
    );
}
